import { v4 as uuidv4 } from "uuid";

import { TJobForm } from "@/features/job/types/JobForm";

export const pickDuplicateJobData = (data: Partial<TJobForm>): Partial<TJobForm> | undefined => ({
  companyId: data.companyId,
  jobName: data.jobName,
  recruiterId: data.recruiterId,
  companySpecificIndustryId: data.companySpecificIndustryId,
  businessClassificationId: data.businessClassificationId,
  companySpecificBusinessClassificationIds: data.companySpecificBusinessClassificationIds,
  // tag (タグ／優先ステータス), startDate (募集開始日), endDate (募集終了日) intentionally
  // excluded — user must re-enter these for the cloned job.
  matchOfficeId: data.matchOfficeId,
  statusMemo: data.statusMemo,
  managementNumber: data.managementNumber,
  recruitmentNumber: data.recruitmentNumber,
  referralFee: data.referralFee,
  referralFeeCost: data.referralFeeCost,
  recruitmentSourceIds: data.recruitmentSourceIds,
  clientType: data.clientType,
  recruiterNote: data.recruiterNote,
  businessContent: data.businessContent,
  employmentType: data.employmentType,
  salaryType: data.salaryType,
  jobSalarySummaries: data.jobSalarySummaries?.map(({ id: _id, _clientId: _oldClientId, ...rest }) => ({
    ...rest,
    _clientId: uuidv4(),
  })),
  otherAllowanceDescription: data.otherAllowanceDescription,
  overtimeDescription: data.overtimeDescription,
  bonus: data.bonus,
  bonusInfo: data.bonusInfo,
  salaryRaise: data.salaryRaise,
  salaryRaiseTime: data.salaryRaiseTime,
  employmentConditionNote: data.employmentConditionNote,
  workplace: data.workplace,
  workplaceDetail: data.workplaceDetail,
  jobWorkingTimes: data.jobWorkingTimes?.map(({ id: _id, ...rest }) => rest),
  regularHolidays: data.regularHolidays,
  irregularHolidays: data.irregularHolidays,
  totalAnnualHolidays: data.totalAnnualHolidays,
  japaneseLevelType: data.japaneseLevelType,
  japaneseLevelOther: data.japaneseLevelOther,
  skillsExperience: data.skillsExperience,
  otherApplicationRequirements: data.otherApplicationRequirements,
  ageLimit: data.ageLimit,
  nationalityIds: data.nationalityIds,
  recruitmentLocationType: data.recruitmentLocationType,
  desiredHiringPeriod: data.desiredHiringPeriod,
  gender: data.gender,
  residenceStatusIds: data.residenceStatusIds,
  specificSkillCertificateIds: data.specificSkillCertificateIds,
  jobDocumentUrl: data.jobDocumentUrl,
  jobDocumentFilePaths: data.jobDocumentFilePaths,
  selectionProcess: data.selectionProcess,
  companyAccommodation: data.companyAccommodation,
  specifiedSkillNo2: data.specifiedSkillNo2,
  otherBenefits: data.otherBenefits,
  insuranceStatus: data.insuranceStatus,
  selfExpense: data.selfExpense,
  companyFeatures: data.companyFeatures,
  foreignEmployees: data.foreignEmployees,
  onboardingSupport: data.onboardingSupport,
  relatedFileTitles: data.relatedFileTitles,
  relatedFilePaths: data.relatedFilePaths,
  jobUploadFiles: data.jobUploadFiles?.map(({ id: _id, createdAt: _createdAt, ...rest }, index) => ({
    ...rest,
    id: index, // synthetic id for UI list key only; BE will assign real id on save
    createdAt: "",
  })),
});
